import { createContext } from 'react';
import ChartFactory from './СhartFactory';

// eslint-disable-next-line import/prefer-default-export
export const ChartFactoryContext = createContext(new ChartFactory());
